import { service } from '../../../pages/reports/Dashboard/service/transportationsResource';
import moment from 'moment';
import CarPoint from '../../../assets/images/carPointIcon.svg';
import { useEffect, useState } from 'react';
export const VehicleInfo = ({ data }) => {
  const [driver, setDriver] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const params = {
      sort: 'createdAt,desc',
      size: 1,
    };
    const fetchDriver = async () => {
      try {
        const driver = await service.findByTransportationWithVehicleId(
          data.vehiclePlate,
          params,
        );
        if (driver.data.data.length === 0) {
          setDriver({ message: 'Sürücü bilgisi bulunamadı' });
          return;
        }
        setDriver(driver.data.data[0]);
      } catch (error) {
        setDriver({ message: 'Sürücü bilgisi bulunamadı' });
      } finally {
        setLoading(false);
      }
    };
    fetchDriver();
  }, [data.vehiclePlate]);

  return (
    <div className="flex w-full items-center justify-center gap-4 h-full flex-col p-5">
      <div className="flex flex-row w-full h-full items-center justify-between">
        <div className="flex h-full  items-center flex-row gap-2">
          <div className="size-14 flex items-center justify-center p-2 rounded-full bg-[#304564]">
            <img
              src={CarPoint}
              alt="carPoint"
              className="object-contain size-full"
            />
          </div>
          <div className="flex items-center  text-sm flex-col">
            <div>{data?.vehiclePlate}</div>
            <div className="w-full text-left text-gray-500 italic">Aktif</div>
          </div>
        </div>
      </div>
      <div className="flex text-left flex-row gap-3 justify-between w-full text-sm">
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Sürücü</div>
          <div className="w-full">
            {loading
              ? 'Yükleniyor ...'
              : driver?.hasOwnProperty('message')
                ? driver.message
                : driver?.transportation?.driver?.firstname +
                  ' ' +
                  driver?.transportation?.driver?.lastname}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Hız</div>
          <div className="w-full">{data.speed} km/s</div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Kordinat</div>
          <div className="w-full">
            {data.latitude},{data.longitude}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Tarih ve Saat</div>
          <div className="w-full">
            {moment(data.localDateTime).format('DD.MM.YYYY HH:MM')}
          </div>
        </div>
      </div>
    </div>
  );
};
